import { ReduxService } from 'dashboard-services/services';

import { templatesInsightActions } from 'actions/modules/insight';

export const templatesInitialState = {
  // creating insight from template
  activeTemplate: undefined,
  activeTemplateInfo: undefined,
  activeTask: undefined,

  // both
  selectedParams: {},

  // creating template
  selectedTask: undefined,
  selectedInsight: undefined,
  tiles: [],
  inputParams: [],
  templateName: undefined,
  groupName: undefined,
  description: undefined
}

export const templatesState = (state = templatesInitialState, action) => {
  switch (action.type) {
    case templatesInsightActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case templatesInsightActions.ON_CHANGE_SELECTED_PARAMS: {
      if(state.selectedParams[action.name] !== action.value) {
        return ReduxService.updateObject(state, { selectedParams: ReduxService.updateObject(state.selectedParams, { [action.name]: action.value }) })
      }
      return state;
    }
    case templatesInsightActions.ON_CHANGE_SELECTED_PARAM: {
      if(state.selectedParams[action.paramName]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { selectedParams: ReduxService.updateObject(state.selectedParams, { [action.paramName]: ReduxService.updateObject(state.selectedParams[action.paramName], { [action.name]: action.value }) }) })
      }
      return state;
    }
    case templatesInsightActions.ON_CHANGE_LIST: {
      if(state[action.listName]?.[action.index]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.listName]: state[action.listName].updateInList({ [action.name]: action.value }, action.index) })
      }
      return state;
    }
    case templatesInsightActions.CLEAR:
      return templatesInitialState;
    default:
      return state;
  }
}